export default __webpack_public_path__ + "static/media/challenge-icon-in-card.0c70df88.svg";